import * as React from "react";

import styles from "./FormSectionCard.module.css";

export interface FormSectionCardProps {
  icon: string;
  title: string;
  /** e.g. an author-supervision toggle rendered at the right of the header */
  rightSlot?: React.ReactNode;
  hint?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/** White card grouping a titled section of the signatory editor form. */
export const FormSectionCard: React.FC<FormSectionCardProps> = ({ icon, title, rightSlot, hint, children, className }) => (
  <div className={`${styles.card}${className ? ` ${className}` : ``}`}>
    <div className={styles.header}>
      <span className={styles.iconBadge}>
        <i className={icon} />
      </span>
      <span className={styles.title}>{title}</span>
      {rightSlot && <span className={styles.right}>{rightSlot}</span>}
    </div>
    <div className={styles.grid}>{children}</div>
    {hint && <div className={styles.hint}>{hint}</div>}
  </div>
);
